import { render, staticRenderFns } from "./SideNavClient.vue?vue&type=template&id=6899fde8&scoped=true&"
import script from "./SideNavClient.vue?vue&type=script&lang=js&"
export * from "./SideNavClient.vue?vue&type=script&lang=js&"
import style0 from "./SideNavClient.vue?vue&type=style&index=0&id=6899fde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899fde8",
  null
  
)

export default component.exports